import React, { useContext, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import { initSurvey } from '../qualtricsHelper';
import './search-feedback.scss';

const SearchFeedback = (props) => {
  const { channel } = useContext(ExperienceContext);

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('search-feedback.ready');
    initSurvey();
  }, []);

  if (channel === 'mobile') return null;

  const { type } = props;

  const rowClasses = classNames({
    collectionFeedbackWrapper: type === 'collection'
  });

  const columnClasses = classNames({
    'article-feedback-wrapper': type === 'articles',
    'search-feedback-wrapper': type !== 'articles'
  });

  return (
    <Row className={rowClasses}>
      <Col className={columnClasses}>
        <div id={`${type}Feedback`} />
      </Col>
    </Row>
  );
};

SearchFeedback.displayName = 'SearchFeedback';

SearchFeedback.propTypes = {
  type: PropTypes.oneOf([
    'articles',
    'search',
    'collection'
  ])
};

SearchFeedback.defaultProps = {
  type: 'search',
};

export { SearchFeedback };
